module.exports = __webpack_public_path__ + "static/media/grupo-via.decb49e9.svg";